import { Star } from "lucide-react";

const ROW = [0, 1, 2, 3, 4];

export const formatRating = (value) => (Number(value) || 0).toFixed(1).replace(".", ",");

export const Stars = ({ value = 0, size = "h-4 w-4", testid }) => {
  const pct = Math.max(0, Math.min(100, (Number(value) / 5) * 100));
  return (
    <span className="relative inline-flex shrink-0" role="img" aria-label={`${formatRating(value)} stelle su 5`} data-testid={testid}>
      <span className="flex gap-0.5 text-copper/30">{ROW.map((i) => <Star key={i} className={size} strokeWidth={1.5} />)}</span>
      <span className="absolute inset-0 flex gap-0.5 overflow-hidden text-gold" style={{ width: `${pct}%` }}>
        {ROW.map((i) => <Star key={i} className={`${size} shrink-0 fill-current`} strokeWidth={1.5} />)}
      </span>
    </span>
  );
};

export const StarPicker = ({ value, onChange, name }) => (
  <div role="radiogroup" aria-label="Il tuo voto" className="flex gap-1" data-testid={`star-picker-${name}`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        role="radio"
        aria-checked={value === n}
        aria-label={`${n} ${n === 1 ? "stella" : "stelle"}`}
        onClick={() => onChange(n)}
        data-testid={`star-${name}-${n}`}
        className="grid h-12 w-12 place-items-center rounded-full transition-transform duration-200 hover:scale-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-copper"
      >
        <Star className={`h-8 w-8 ${n <= value ? "fill-gold text-gold" : "text-copper/40"}`} strokeWidth={1.5} />
      </button>
    ))}
  </div>
);
